import { Modal } from 'flowbite-react'
import React, { useEffect, useState } from 'react'
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup'
import { FormProvider, useForm } from 'react-hook-form';
import { companyRegister } from '../../api/companyCreation';
import { validateEmailAvailable } from '../../api/auth';
import toast from 'react-hot-toast';
import { FeaturesListData } from '../../Data/FeaturesListData'
import cardTopLeft from "../../assets/Images/FormModal/CARD LEFT TOP.png"
import cardBottomRight from "../../assets/Images/FormModal/card bottom right.png"
import bg from "../../assets/Images/FormModal/bg3.svg"
import "./FormModal.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import SuccessModalApproval from '../SuccessModalApproval/SuccessModalApproval';

const TEAM_SIZE_OPTIONS = [
    { label: '1 – 5 employees', value: '5' },
    { label: '6 – 20 employees', value: '20' },
    { label: '21 – 50 employees', value: '50' },
    { label: '50+ employees', value: '100' },
];

const FormModal = ({ isModal, toggle = () => { }, isOpenForm, toggleForm = () => { }, mobile, onHandoffComplete = () => { } }) => {

    const [openSuccess, setOpenSuccess] = useState(false)
    const formVisible = Boolean(isOpenForm || isModal)

    const schema = yup.object().shape({
        name: yup.string().required('Please enter your name'),
        companyName: yup.string().required('Please enter your company name'),
        companyEmail: yup
            .string()
            .required('Work email is required')
            .email('Enter a valid email address'),
        companyMobile: yup.string()
            .required('Mobile is required')
            .matches(/^\d{10}$/, 'Mobile number should be exactly 10 digits'),
        employees: yup.string().required('Please select team size'),
    });

    const methods = useForm({
        resolver: yupResolver(schema),
        mode: 'onChange',
    });

    const { handleSubmit, register, setValue, reset, formState: { errors, isSubmitting } } = methods;

    function handleGoToDashboard() {
        setOpenSuccess(false)
        reset()
        onHandoffComplete()
    }

    function handleDismissSuccess() {
        setOpenSuccess(false)
    }

    function closeFormModal() {
        if (isOpenForm) toggleForm()
        if (isModal) toggle()
    }

    const onSubmit = async (data) => {
        const email = data.companyEmail.trim()
        try {
            const availability = await validateEmailAvailable(email)
            if (availability?.status >= 400) {
                toast.error(availability?.data?.msg || 'Email is already registered')
                return
            }
        } catch (error) {
            toast.error(error?.response?.data?.msg || 'Could not validate email')
            return
        }

        const payload = {
            companyName: data.companyName,
            email,
            mobile: data.companyMobile,
            noOfEmployees: Number(data.employees),
            name: data.name,
        }

        try {
            const updateApi = await companyRegister(payload)
            if (updateApi?.status >= 400) {
                toast.error(updateApi?.data?.msg || 'Registration failed')
                return
            }
            toast.success('Company registered successfully')
            closeFormModal()
            reset()
            setOpenSuccess(true)
        } catch (error) {
            toast.error(error?.response?.data?.msg || 'Registration failed')
        }
    }

    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        centerMode: false,
        autoplay: true,
        responsive: [
            { breakpoint: 1300, settings: { arrows: false, slidesToShow: 1 } },
            { breakpoint: 908, settings: { arrows: false, slidesToShow: 1 } },
            { breakpoint: 600, settings: { arrows: false, slidesToShow: 1 } },
        ],
    };

    useEffect(() => {
        if (mobile) {
            setValue('companyMobile', mobile)
        }
    }, [mobile, setValue])

    return (
        <>
            <Modal size='2xl' className='hide-scrollbar overflow-y-scroll font-poppins' show={formVisible && !openSuccess} onClose={closeFormModal} >
                <FormProvider {...methods}>
                    <Modal.Body>
                        <div className='grid grid-cols-12 gap-x-4'>

                            <div className='col-span-6 bg-[#f6f6f6] border-[1px] border-[#dfdfdf] relative rounded-md w-full mx-auto flex flex-col justify-between gap-10 px-5 py-4 overflow-hidden'>
                                <img src={bg} className='absolute top-0 left-0' alt="" />
                                <div className='z-50'>
                                    <h2 className="text-primaryColor text-2xl font-bold">Welcome To CHITBID</h2>
                                    <p className='text-md mt-4'>Quick signup here. You will verify your work email inside the dashboard.</p>
                                </div>
                                <div className='bg-[#642019] rounded-lg p-3 py-10 w-full relative mx-auto z-50 mb-10'>
                                    <img className='h-16 absolute top-0 left-0' src={cardTopLeft} alt="icon" />
                                    <img className='h-16 absolute bottom-0 right-0' src={cardBottomRight} alt="icon" />
                                    <Slider {...settings} className='custom-dots'>
                                        {FeaturesListData.slice(0, 5).map((item, i) => (
                                            <div key={i}>
                                                <div className='w-full text-center flex flex-col items-center justify-center relative'>
                                                    <img className='h-14' src={item.color_icon} alt="icon" />
                                                    <h1 className='text-sm font-poppins font-bold text-white mt-3 mb-1'>{item.title}</h1>
                                                    <p className='text-xs font-poppins text-[#e3e5edf4]'>{item.para ? item.para.slice(0, 120) + "..." : ""}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            </div>

                            <div className='col-span-6'>
                                <form onSubmit={handleSubmit(onSubmit)} className='h-full'>
                                    <div>
                                        <h2 className='mb-1 font-bold text-xl'>Register your company</h2>
                                        <p className='text-xs text-gray-500 mb-4'>This work email will be used to sign in. You will verify it on the next screen.</p>

                                        <div className='col-span-12'>
                                            <div className='font-medium text-sm'>Your name<span className='text-danger-500 ms-1'>*</span></div>
                                            <div className="mt-1">
                                                <input id='name' type="text" placeholder='Enter your name' className='bg-gray-100 border-[1px] border-gray-300 rounded-md w-full placeholder:text-xs px-3 py-2' {...register('name')} />
                                                {errors.name && <p className='text-red-500 text-xs mt-1 font-medium'>{errors.name.message}</p>}
                                            </div>
                                        </div>

                                        <div className='col-span-12 mt-3'>
                                            <div className='font-medium text-sm'>Mobile<span className='text-danger-500 ms-1'>*</span></div>
                                            <div className="mt-1">
                                                <input id='companyMobile' type="text" readOnly className='bg-gray-200 border-[1px] border-gray-300 rounded-md w-full px-3 py-2 text-gray-600' {...register('companyMobile')} />
                                            </div>
                                        </div>

                                        <div className='col-span-12 mt-3'>
                                            <div className='font-medium text-sm'>
                                                Work email<span className='text-danger-500 ms-1'>*</span>
                                                <span className='text-gray-400 font-normal'> (verify in dashboard)</span>
                                            </div>
                                            <div className="mt-1">
                                                <input id='companyEmail' type="email" placeholder='you@company.com' className='bg-gray-100 border-[1px] border-gray-300 rounded-md w-full placeholder:text-xs px-3 py-2' {...register('companyEmail')} />
                                                {errors.companyEmail && <p className='text-red-500 text-xs mt-1 font-medium'>{errors.companyEmail.message}</p>}
                                            </div>
                                        </div>

                                        <div className='col-span-12 mt-3'>
                                            <div className='font-medium text-sm'>Company name<span className='text-danger-500 ms-1'>*</span></div>
                                            <div className="mt-1">
                                                <input id='companyName' type="text" placeholder='Enter your company name' className='bg-gray-100 border-[1px] border-gray-300 rounded-md w-full placeholder:text-xs px-3 py-2' {...register('companyName')} />
                                                {errors.companyName && <p className='text-red-500 text-xs mt-1 font-medium'>{errors.companyName.message}</p>}
                                            </div>
                                        </div>

                                        <div className='col-span-12 mt-3'>
                                            <div className='font-medium text-sm'>Team size<span className='text-danger-500 ms-1'>*</span></div>
                                            <div className="mt-1">
                                                <select id='employees' className='bg-gray-100 border-[1px] border-gray-300 rounded-md w-full text-sm px-3 py-2' {...register('employees')}>
                                                    <option value="">Select team size</option>
                                                    {TEAM_SIZE_OPTIONS.map((opt) => (
                                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                    ))}
                                                </select>
                                                {errors.employees && <p className='text-red-500 text-xs mt-1 font-medium'>{errors.employees.message}</p>}
                                            </div>
                                        </div>

                                        <div className='mt-5'>
                                            <button type='submit' disabled={isSubmitting} className='bg-[#642019] px-5 py-2 text-md rounded-lg text-white disabled:opacity-50'>
                                                {isSubmitting ? 'Submitting…' : 'Continue to dashboard'}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal.Body>
                </FormProvider>
            </Modal>

            <SuccessModalApproval
                openSuccess={openSuccess}
                onGoToDashboard={handleGoToDashboard}
                onDismiss={handleDismissSuccess}
            />
        </>
    )
}

export default FormModal
